import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-123b511a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "idea-info render-hide-scroll"
};
const _hoisted_2 = {
  key: 0,
  class: "warning"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "当前创意未通过审核，内容修改中...", -1));
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "render-line-clamp",
  src: "https://p6.moimg.net/md/icon/project_title_icon@2x.png"
}, null, -1));
const _hoisted_7 = {
  class: "category"
};
const _hoisted_8 = {
  class: "tit"
};
const _hoisted_9 = {
  class: "stage_info"
};
const _hoisted_10 = {
  key: 0,
  class: "time"
};
const _hoisted_11 = {
  key: 0,
  class: "time"
};
const _hoisted_12 = /*#__PURE__*/_createTextVNode("去购买支持");
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-nestmoreweibo"
}, null, -1));
const _hoisted_14 = [_hoisted_12, _hoisted_13];
const _hoisted_15 = {
  class: "icon"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "info"
};
const _hoisted_18 = {
  class: "nick_name"
};
const _hoisted_19 = {
  class: "cp_going_project"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "发起者承诺如当前创意启动销售，将在摩点发起众筹", -1));
const _hoisted_21 = {
  class: "history-update"
};
const _hoisted_22 = {
  key: 0,
  class: "title"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tit"
}, "暂无讨论", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "edit"
}, "喜欢就来好评吧", -1));
const _hoisted_25 = [_hoisted_23, _hoisted_24];
const _hoisted_26 = {
  key: 1,
  class: "title"
};
const _hoisted_27 = {
  class: "tit"
};
const _hoisted_28 = {
  key: 1,
  class: "history-update"
};
const _hoisted_29 = {
  class: "title"
};
const _hoisted_30 = {
  class: "tit"
};
const _hoisted_31 = {
  class: "update_number"
};
const _hoisted_32 = {
  class: "update_content"
};
const _hoisted_33 = {
  class: "render-line-clamp"
};
const _hoisted_34 = ["src"];
const _hoisted_35 = {
  key: 2,
  class: "history-update update-list-title"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "tit"
}, "创意历程")], -1));
const _hoisted_37 = [_hoisted_36];
const _hoisted_38 = {
  key: 4,
  class: "borderBg"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "history_date_item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/idea_detail_first_update_icon.png"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "history_date_item_title"
}, "首次更新 ")], -1));
const _hoisted_40 = [_hoisted_39];
const _hoisted_41 = {
  key: 5,
  ref: "editorBox",
  class: "borderBg"
};
const _hoisted_42 = {
  key: 6,
  class: "bottom_btn"
};
const _hoisted_43 = {
  key: 0,
  class: "num"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "戳表情", -1));
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "看好创意", -1));
const _hoisted_46 = [_hoisted_44, _hoisted_45];
const _hoisted_47 = {
  key: 1,
  class: "num active_num"
};
const _hoisted_48 = {
  class: "total"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "看好人数", -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/idea_favor_icon_normal.png"
}, null, -1));
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tit"
}, "看好这个创意", -1));
const _hoisted_52 = [_hoisted_50, _hoisted_51];
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tit"
}, "感谢看好", -1));
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "创意有更新会及时通知你", -1));
const _hoisted_55 = [_hoisted_53, _hoisted_54];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_CompHeader = _resolveComponent("CompHeader");
  const _component_CompIdeaTopSwiper = _resolveComponent("CompIdeaTopSwiper");
  const _component_CompCommentList = _resolveComponent("CompCommentList");
  const _component_CompUpdateList = _resolveComponent("CompUpdateList");
  const _component_van_list = _resolveComponent("van-list");
  const _component_CompToPay = _resolveComponent("CompToPay");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CompHeader, {
    ref: "compHeader",
    name: $data.idea_info.title,
    is_can_share: $data.idea_info.is_can_share,
    is_idea: true
  }, null, 8, ["name", "is_can_share"]), _createVNode(_component_CompIdeaTopSwiper, {
    logos: $data.idea_info.logos
  }, null, 8, ["logos"]), $data.idea_info.status == 21 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
    src: `${_ctx.$imgUrlFilter('https://p6.moimg.net/path/dst_project/1198698/202303/0318/0052/2303030052KdRY4m905Mjyo6AxAeEW7QxDqoLekp.png', 60)}`
  }, null, 8, _hoisted_3), _hoisted_4])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("h2", null, [_hoisted_6, _createTextVNode(" " + _toDisplayString($data.idea_info.title), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString($data.idea_info.category), 1), $data.idea_info.same_going_project ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "more",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goProjectList && $options.goProjectList(...args))
  }, _toDisplayString($data.idea_info.same_going_project), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.idea_info.stage_info, (stage, stageIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: stageIndex
    }, [_createElementVNode("p", {
      class: _normalizeClass({
        'active': stage.is_start
      })
    }, _toDisplayString(stage.current_stage_name), 3), stageIndex < 2 ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(stage.start_time || '待定'), 1)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [!stage.is_start ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(stage.start_time || '待定'), 1)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "toPay",
      onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => $options.toPay && $options.toPay(...args), ["stop"]))
    }, _hoisted_14))], 64)), stageIndex < 2 ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      class: _normalizeClass(['line', {
        'success': $data.idea_info.stage_info[stageIndex + 1].is_start
      }, {
        'process': stage.is_start && !$data.idea_info.stage_info[stageIndex + 1].is_start
      }])
    }, null, 2)) : _createCommentVNode("", true)]);
  }), 128))]), _createElementVNode("div", {
    class: "index_cp_info",
    onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => $options.goUserCenter && $options.goUserCenter(...args), ["stop"]))
  }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
    src: `${_ctx.$imgUrlFilter($data.idea_info.index_cp_info && $data.idea_info.index_cp_info.icon || '', 152)}`
  }, null, 8, _hoisted_16)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("p", _hoisted_18, _toDisplayString($data.idea_info.index_cp_info && $data.idea_info.index_cp_info.nick_name), 1), _createElementVNode("p", _hoisted_19, _toDisplayString($data.idea_info.index_cp_info && $data.idea_info.index_cp_info.cp_going_project), 1)]), !$data.isFollow && $data.idea_info.index_cp_info && _ctx.userId != $data.idea_info.index_cp_info.user_id ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "btn",
    onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.UserFollow && $options.UserFollow(...args), ["stop"]))
  }, "关注TA")) : _createCommentVNode("", true)]), _hoisted_20]), _createElementVNode("div", _hoisted_21, [$data.comment_total == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25)) : (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, "讨论（" + _toDisplayString($data.comment_total) + "）", 1), _createElementVNode("span", {
    class: "more",
    onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.goToApp && $options.goToApp(...args), ["stop"]))
  }, "查看更多")]))]), _createVNode(_component_CompCommentList, {
    comment_list: $data.comment_list
  }, null, 8, ["comment_list"]), $data.idea_info.history_update_info && $data.idea_info.history_update_info.history_update_count > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, "历史更新（" + _toDisplayString($data.idea_info.history_update_info && $data.idea_info.history_update_info.history_update_count) + "）", 1), _createElementVNode("span", {
    class: "more",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.goUpdateList && $options.goUpdateList(...args))
  }, "查看更多")]), _createElementVNode("div", _hoisted_31, [_createElementVNode("p", null, "第" + _toDisplayString($data.idea_info.history_update_info && $data.idea_info.history_update_info.update_number) + "次更新", 1), _createElementVNode("p", null, _toDisplayString($data.idea_info.history_update_info && $data.idea_info.history_update_info.update_time), 1)]), _createElementVNode("div", _hoisted_32, [_createElementVNode("p", _hoisted_33, _toDisplayString($data.idea_info.history_update_info && $data.idea_info.history_update_info.update_title), 1), _createElementVNode("img", {
    src: `${_ctx.$imgUrlFilter($data.idea_info.history_update_info && $data.idea_info.history_update_info.update_logo || '', 412)}`
  }, null, 8, _hoisted_34)])])) : _createCommentVNode("", true), $data.update_list.length > 0 || $data.hasHistoryData ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37)) : _createCommentVNode("", true), $data.update_list.length > 0 ? (_openBlock(), _createBlock(_component_van_list, {
    key: 3,
    loading: $data.updateLoading,
    "onUpdate:loading": _cache[6] || (_cache[6] = $event => $data.updateLoading = $event),
    finished: !$data.is_next,
    "immediate-check": false,
    onLoad: $options.onLoad
  }, {
    default: _withCtx(() => [_createVNode(_component_CompUpdateList, {
      update_list: $data.update_list
    }, null, 8, ["update_list"])]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"])) : _createCommentVNode("", true), $data.update_list.length > 0 && $data.idea_info.is_history_data ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40)) : _createCommentVNode("", true), $data.idea_info.is_history_data ? (_openBlock(), _createElementBlock("div", _hoisted_41, null, 512)) : _createCommentVNode("", true), $data.idea_info.idea_favor_info ? (_openBlock(), _createElementBlock("div", _hoisted_42, [$options.fovor_total == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_46)) : (_openBlock(), _createElementBlock("div", _hoisted_47, [_createElementVNode("p", _hoisted_48, _toDisplayString($options.fovor_total), 1), _hoisted_49])), !$options.is_attitude ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "interact",
    onClick: _cache[7] || (_cache[7] = _withModifiers($event => $options.idea_favor(), ["stop"]))
  }, _hoisted_52)) : (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "interact interact_active",
    onClick: _cache[8] || (_cache[8] = _withModifiers($event => $options.idea_favor(), ["stop"]))
  }, _hoisted_55))])) : _createCommentVNode("", true), _createVNode(_component_CompToPay, {
    show: $data.showPayVisible,
    proInfo: $data.proInfo,
    onConfirm: $options.toPay,
    onClose: _cache[9] || (_cache[9] = $event => $data.showPayVisible = false)
  }, null, 8, ["show", "proInfo", "onConfirm"])]));
}